import { IAdminUser } from '@dadohr/shared/domainTypes/adminUser';
import { Doc } from '@dadohr/shared/domainTypes/document';
import { FS } from '@dadohr/shared/versions';
import { batchSetDocs } from '../../../services/firebase';
import { callFirebaseFunction } from '../../../services/firebaseFunctions';
import { now } from '../../../services/time';

export const grantAdminClaim = (userId: string) => {
  return callFirebaseFunction('admin-grantAdminClaim', { userId });
};

export const revokeAdminClaim = (userId: string) => {
  return callFirebaseFunction('admin-revokeAdminClaim', { userId });
};

const DEV_CANDIDATES = [
  {
    id: '1w3yC2AkrwPhCjEx7CWzlWMQFCN2',
    email: 'gernot.emplexp@gmail.com',
    firstName: 'Gernot',
    lastName: 'Hoeflechner'
  },
  {
    id: 'ldRaOPYH1UNuwV9kNHVq6w168EQ2',
    email: 'arielle.emplexp@gmail.com',
    firstName: 'Arielle',
    lastName: 'Kilroy'
  },
  {
    id: 'olba56m4bFVryUlvl5EAl3q4IGH2',
    email: 'gabriel.emplexp@gmail.com',
    firstName: 'Gabriel',
    lastName: 'Lovato'
  },
  {
    id: 'wqwdv3SbDEPynvkvXzNoCHg8Pc13',
    email: 'scott.emplexp@gmail.com',
    firstName: 'Scott',
    lastName: 'Faverty'
  }
];

const PROD_CANDIDATES = [
  {
    id: 'ICdK6Dv5uOgnz1SQu2pOZcXk3rU2',
    email: 'gernot.emplexp@gmail.com',
    firstName: 'Gernot',
    lastName: 'Hoeflechner'
  },
  {
    id: 'ldKVQrrtrufptn4avsPf57uQHWr2',
    email: 'arielle.emplexp@gmail.com',
    firstName: 'Arielle',
    lastName: 'Kilroy'
  },
  {
    id: 'bVB5j7nEcLUMMOmzG52eHQkBQsh2',
    email: 'gabriel.emplexp@gmail.com',
    firstName: 'Gabriel',
    lastName: 'Lovato'
  },
  {
    id: 'M6p5oA1s0teXkFVPZ6o1enbSiY52',
    email: 'scott.emplexp@gmail.com',
    firstName: 'Scott',
    lastName: 'Faverty'
  }
];

export const createFromCandidates = async (
  candidates: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  }[],
  execute: boolean
) => {
  const createdAt = now();
  const createdBy = candidates[0].id;

  const users: Doc<IAdminUser>[] = candidates.map(
    ({ id, email, firstName, lastName }) => {
      const data: IAdminUser = {
        email,
        firstName,
        lastName,
        middleName: '',
        preferredName: firstName,
        avatar: '',
        createdAt,
        createdBy,
        orgs: []
      };
      return { id, collection: FS.adminUsers, data };
    }
  );

  console.log(users);
  if (execute) {
    await batchSetDocs(users);
  }
  return users;
};

export const initialSetup = async (env: 'PROD' | 'DEV', execute: boolean) => {
  const candidates = env === 'PROD' ? PROD_CANDIDATES : DEV_CANDIDATES;
  const adminUsers = await createFromCandidates(candidates, execute);
  if (execute) {
    await Promise.all(adminUsers.map((u) => grantAdminClaim(u.id)));
  }
};
